export default {
  getTimetable: (state) => state.timetable,
  getTimetableIsError: (state) => state.status.isError,
  getTimetableError: (state) => state.status.error,
  getTimetableIsLoading: (state) => state.status.isLoading
};
